import {bindable} from "aurelia-framework";

import "./loading-overlay.less";

export class LoadingOverlay {
    @bindable loading;
    @bindable small = false;
}
